import React, {Component, Fragment} from 'react'
import { withRouter, Prompt } from 'react-router-dom'
import { MuiThemeProvider } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography'
import StyleSheet, {darkTheme} from 'styles'
import Button from '@material-ui/core/Button'

export class NavigationConfirmation extends Component {
  state = {show: false}

  handlePrompt = location => {
    if (this.props.location.pathname.match(/\/new(\/(\w*))?$/) && location.pathname.match(/\/\d+(\/(\w*))?$/))
      return true

    this.setState({location, show: true})
    return false
  }

  closePrompt = () => {
    this.setState({show: false})
  }

  handleSave = async() => {
    try {
      await this.props.onSave()
      this.props.history.push(this.state.location)
    }
    finally {
      this.closePrompt()
    }
  }

  handleDiscard = () => {
    this.props.history.push(this.state.location)
    this.closePrompt()
  }

  handleCancel = () => {
    this.closePrompt()
  }

  render = () =>
    <Fragment>
      <Prompt when={!!this.props.when && !this.state.show} message={this.handlePrompt} />
      <MuiThemeProvider theme={darkTheme}>
        <Dialog open={this.state.show}>
          <DialogTitle className={styles.title}>
            Unsaved Changes
          </DialogTitle>
          <DialogContent className={styles.content}>
            <Typography variant='body2'>{this.props.message}</Typography>
          </DialogContent>
          <DialogActions className={styles.actions} classes={{action: styles.action}}>
            <Button className={styles.button}
                    variant='contained' onClick={this.handleCancel}
                    color='secondary'>Cancel</Button>
            <Button className={styles.button}
                    variant='contained' onClick={this.handleDiscard}
                    color='secondary'>Discard</Button>
            <Button className={styles.button}
                    variant='contained' onClick={this.handleSave}
                    color='primary'>Save</Button>
          </DialogActions>
        </Dialog>
      </MuiThemeProvider>
    </Fragment>
}

const styles = StyleSheet({
  actions: {
    margin: [8,20,24,20]
  },
  button: {
    width: 99
  }
})

export default withRouter(NavigationConfirmation)